import React from 'react';
import {
    HeroImage as LandingPageTeaserUi,
    LandingPageMarketingCardLoadingPlaceholder,
    useAnalyticsActionTracker,
    useAnalyticsPageViewTracker,
} from '@cp-shared-19/frontend-ui';
import { useLandingPageTeaser } from './useLandingPageTeaser';

import { withLoadingAndNoConnectionHandler } from '../integration-wrapper';
import { useLogin } from 'auth';

const LandingPageTeaserWithHandlers = withLoadingAndNoConnectionHandler(LandingPageTeaserUi);

export const LandingPageTeaser: React.FC = () => {
    const { cmsContent: landingPageTeaser, isLoading, loadingError } = useLandingPageTeaser();
    const login = useLogin();

    const { onAction } = useAnalyticsActionTracker('login');
    useAnalyticsPageViewTracker('landingPage', true);

    const onClick = (): void => {
        onAction();
        login();
    };

    return (
        <LandingPageTeaserWithHandlers
            isLoading={isLoading}
            hasError={!!loadingError}
            title={landingPageTeaser?.title || ''}
            subTitle={landingPageTeaser?.subTitle}
            text={landingPageTeaser?.text}
            imageUrl={landingPageTeaser?.imageUrl || ''}
            buttonText={landingPageTeaser?.buttonText}
            buttonAriaLabel={landingPageTeaser?.buttonAriaLabel}
            buttonTitle={landingPageTeaser?.buttonTitle}
            clickHandler={onClick}
            inverted={!!landingPageTeaser?.isInverted}
            loadingPlaceholder={<LandingPageMarketingCardLoadingPlaceholder />}
        />
    );
};
